import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ArrayConfiguration from 'pages/products/configuration/ArrayConfiguration';
import TimeTableCell from 'pages/products/configuration/TimeTableCell';
import styled from 'styled-components';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import validations from 'helpers/forms/validations';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { getRuleConfig } from 'helpers/rulesHelper';
import { compose } from 'recompose';
import { connect } from 'react-redux';

const StyledInputWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const VALUE_PROPERTY = 'value';

class TimeRule extends Component {
    config = null;

    componentDidMount() {
        const {
            initialize,
            value,
            type,
        } = this.props;

        const initialState = {};

        this.config = getRuleConfig(utils.firstCharToLowerCase(type)).config;

        utils.each(this.config, (configValue, property) => {
            initialState[property] = value[property] || null;
        });

        initialize(initialState);
    }

    updateFormState = (values) => {
        const {
            formValues: stateValues,
            onUpdate,
        } = this.props;

        const formValues = { ...stateValues };

        if (values) {
            formValues[VALUE_PROPERTY] = values;
        }

        return onUpdate(formValues);
    }

    componentDidUpdate(prevProps) {
        const {
            formValues: stateValues,
            onUpdate,
            valid,
        } = this.props;

        const formValues = { ...stateValues };

        const diffFormValues = utils.diffObjects(formValues, prevProps.formValues);

        if (!utils.isEmpty(diffFormValues) && valid) {
            const formattedValues = utils.map(formValues.value, (valueObject) => {
                return {
                    from: valueObject.from,
                    to: valueObject.to,
                };
            });

            formValues.value = formattedValues;

            return onUpdate(formValues);
        }
    }

    onAddValue = (name) => {
        const {
            change,
            formValues: {
                value,
            },
        } = this.props;

        const values = [];

        if (!utils.isEmpty(value)) {
            values.push(...value);
        }

        values.push({
            id: Math.floor(Math.random() * Date.now()),
            from: '',
            to: '',
        });

        change(name, values);
    }

    onChangeValue = (event, eventValue, values) => {
        event.preventDefault();

        const {
            change,
            touch,
        } = this.props;

        const { id, name } = event.target;

        const updatedRangeObject = utils.map(values, (valueObject) => {
            if (valueObject.id == id) {
                return {
                    ...valueObject,
                    [name]: eventValue,
                };
            }

            return valueObject;
        });

        change(VALUE_PROPERTY, updatedRangeObject);
        touch(VALUE_PROPERTY);

        this.updateFormState(updatedRangeObject);
    }

    onDeleteValue = (id) => {
        const { change, formValues } = this.props;

        const { value: stateValue } = formValues;

        let value = [
            ...stateValue,
        ];

        if (value.length === 1) {
            return change('value', null);
        }

        value = value.filter((value) => {
            return value.id !== id;
        });

        return change('value', value);
    }

    render() {
        const {
            form,
            type,
        } = this.props;

        if (!this.config) {
            return null;
        }

        return (
            <StyledInputWrapper>
                <Field
                    key={ `${ form }-input-${ VALUE_PROPERTY }` }
                    component={ ArrayConfiguration }
                    inputComponent={ TimeTableCell }
                    id={ type }
                    name={ VALUE_PROPERTY }
                    onAdd={ this.onAddValue }
                    onChange={ this.onChangeValue }
                    onDelete={ this.onDeleteValue }
                    type='time'
                    title={ translate(`resources.products.${ VALUE_PROPERTY }.title`) }
                />
            </StyledInputWrapper>
        );
    }
}

TimeRule.propTypes = {
    change: PropTypes.func.isRequired,
    form: PropTypes.string,
    formValues: PropTypes.shape({
        attribute: PropTypes.string,
        value: PropTypes.arrayOf(PropTypes.object),
    }),
    initialize: PropTypes.func.isRequired,
    onUpdate: PropTypes.func,
    touch: PropTypes.func,
    type: PropTypes.string.isRequired,
    valid: PropTypes.bool.isRequired,
    value: PropTypes.shape({
        attribute: PropTypes.string,
        value: PropTypes.arrayOf(PropTypes.object),
    }),
};

const mapStateToProps = (state, props) => {
    const {
        id,
        type,
    } = props;

    const form = `TimeComponent-${ type }-${ id }`;

    return {
        form: form,
        formValues: getFormValues(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(mapStateToProps, null),
    reduxForm({
        validate: (values, props) => {
            let errors = {};

            for (let property in values) {
                if (values.hasOwnProperty(property)) {
                    const item = values[property];

                    if (utils.isArray(item) && !utils.isEmpty(item)) {
                        utils.each(item, (prop) => {
                            if (utils.isObject(prop)) {
                                utils.each(prop, (propertyValue) => {
                                    errors[property] = validations.required(propertyValue, values, props);
                                });
                            }
                        });

                        continue;
                    }

                    errors[property] = validations.required(item, values, props);
                    continue;
                }
            }

            return errors;
        },
    }),
);

export default enhance(TimeRule);


// WEBPACK FOOTER //
// ./src/pages/discounts/rules/TimeRule.js